import React, {FC} from 'react';

import {TEntityValue} from 'modules/data';

import {
    EStatusCode,
    StatusColor,
    StatusTitle,
    StatusMapping,
} from './status-cell.constants';

import './status-cell.less';

interface IStatusProps {
    value?: TEntityValue;
}

export const Status: FC<IStatusProps> = ({value}: IStatusProps) => {
    const valueToString: string = String(value?.toString().toLowerCase());
    const status: EStatusCode = StatusMapping[valueToString];

    return (
        <div
            className="status"
            style={{color: StatusColor[status]}}
        >
            <div
                className="icon"
                style={{backgroundColor: StatusColor[status]}}
            />
            <div className="title">{StatusTitle[status]}</div>
        </div>
    );
};
